import { Purchases } from '@revenuecat/purchases-js';
import axios from '@helpers/axios';
import { ViewerEntitlementStatus } from '@components/Paywall/paywall.types';

export function isMonetizedSport(
  sport: string | null | undefined,
  vbEnabled = false
): boolean {
  if (!sport) {
    return true; // If sport is not provided, return true
  }
  const monetizedSports = ['bbsb'];
  if (vbEnabled) {
    monetizedSports.push('volleyball');
  }
  let selectedSport = sport.toLowerCase();
  if (selectedSport === 'vb') {
    selectedSport = 'volleyball';
  }
  if (selectedSport === 'baseball' || selectedSport === 'softball') {
    selectedSport = 'bbsb'; // Normalize baseball and softball to bbsb
  }
  return monetizedSports.includes(selectedSport);
}

export async function isLoggedInUserEntitled(): Promise<boolean> {
  const customerInfo = await Purchases.getSharedInstance().getCustomerInfo();
  const activeEntitlements = customerInfo.entitlements.active;
  return activeEntitlements['Pro Access'] !== undefined;
}

export async function isPlayerEntitled(
  playerId: string
): Promise<ViewerEntitlementStatus> {
  const response = await axios.get(
    `/v2/entitlements/players/${playerId}/can_view`
  );
  return response.data.status;
}

export async function isPlayerPublic(playerId: string): Promise<boolean> {
  const response = await axios.get(
    `/v2/entitlements/players/${playerId}/is_public`
  );
  return response.data.isPublic;
}

export async function isAdminOrCoach(teamId: string): Promise<boolean> {
  if (!teamId) {
    return false; // If teamId is not provided, return false
  }
  const response = await axios.get(`/v2/teams/${teamId}/auth`);
  return response.data.status === 200;
}

export async function fetchMonetizationStatus(
  featureFlag: boolean
): Promise<boolean> {
  if (!featureFlag) {
    return axios.get('/api/user/should_see_monetization').then((res) => {
      return res.data.shouldSeeMonetization;
    });
  } else {
    return axios.get('/v2/entitlements/monetization_status').then((res) => {
      return res.data.shouldSeeMonetization;
    });
  }
}
